import React from 'react';
import './AdminMainContent.css';
import Sidebar from '../AdminiSidebarComponent/AdminiSidebarComponent';
import Dashboard from '../Dashboard/Dashboard'; // Default import
import Teachers from '../Teachers/Teachers'; // Default import
import Students from '../Students/Students'; // Default import
import Classes from '../Classes/Classes'; // Default import
import Payments from '../Payments/Payments'; // Default import
import { Routes, Route } from 'react-router-dom';
import Subjects from '../Subjects/Subjects';
import Published from '../Published/Published';
import EventsLogs from '../EventsLogs/EventsLogs';
import UploadVideo from '../UploadVideo/UploadVideo';
import UserManagement from '../UserManagement/UserManagement';
import Questions from '../Questions/Questions';

function MainContent({ setLoggedIn, deviceId, userIp }) {
  return (
    <div className="Adminstrator">
      <Sidebar />
      <div className="main-content">
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/teachers" element={<Teachers />} />
          <Route path="/students" element={<Students />} />
          <Route path="/subjects" element={<Subjects />} />
          <Route path="/questions" element={<Questions />} />
          <Route path="/classes" element={<Classes />} />
          <Route path="/published" element={<Published />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/events" element={<EventsLogs />} />
          <Route path="/createClass" element={<UploadVideo />} />
          <Route path="/user" element={<UserManagement />} />
        </Routes>
      </div>
    </div>
  );
}

export default MainContent;